module.exports = __webpack_public_path__ + "1348d1c509fe058cfa09b68d3a2396a5.png";